const PERMISSION_KEY = "core:tenant_auth_config";
const PAGE_URL = {
    TENANT_AUTH_CONFIG_PAGE: "/admin/core/tenant-auth-config"
}

export {PERMISSION_KEY, PAGE_URL}

